const api_url = process.env.REACT_APP_BACKEND_URL;

export type History = {
  id: number,
  date: Date,
  content: string,
};

type Res = {
  id: number,
  date: string,
  content: string,
};

export const fetchHistory = async () => {
  const endpoint = `${api_url}/history`;

  const data: Res[] = await fetch(endpoint).then((response) => response.json());
  const historyList: History[] = data.map((r) => {
    const newDate: Date = new Date(r.date);
    const history: History = { ...r, date: newDate };
    return history;
  });
  return historyList;
};
